<template>
  <b-form @submit="onSubmit" class="frm-tabs">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>{{ mesa_diretora.nome }}</b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="bagsis">Salvar</b-button>

            <router-link
              :to="{
                name: 'mesas_diretoras_list',
              }"
              class="btn btn-outline-muted mr-2"
              >Cancelar</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.composicao"
            />
            Composição
          </template>
          <Composicao ref="composicao" />
        </b-tab>
        <b-tab lazy :disabled="!hasSaved">
          <template #title>
            <span :class="classAgenda">Agenda</span>
          </template>
          <tab-agenda
            :agenda="agenda"
            type="mesa_diretora"
            :model-id="mesa_diretora.id"
            @update-value="agenda = $event"
          />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import DadosBasicos from "./Form/DadosBasicos.vue";
import Composicao from "./Form/Composicao.vue";
import TabAgenda from "@/modules/agendas/Components/TabAgenda.vue";

export default {
  components: { DadosBasicos, Composicao, TabAgenda },
  data: () => ({
    validations: {
      dados_basicos: true,
      composicao: true,
    },
  }),
  computed: {
    ...mapState("mesas_diretoras", ["mesa_diretora"]),
    hasSaved() {
      return this.mesa_diretora && "id" in this.mesa_diretora;
    },
    classAgenda() {
      return this.hasSaved ? "" : "text-muted";
    },
    agenda: {
      get() {
        return this.mesa_diretora.agenda || {};
      },
      set(value) {
        this.mesa_diretora.agenda = value;
      },
    },
  },
  methods: {
    ...mapActions("mesas_diretoras", ["ActionSave"]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          await this.ActionSave(this.mesa_diretora);
          this.$emit("saved", this.mesa_diretora.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      this.validations.composicao = this.$refs.composicao.isValid();
      return Object.values(this.validations).every(Boolean);
    },
  },
  async created() {},
};
</script>
